export default __webpack_public_path__ + "assets/b7c243015cec15850248814a6a37b2f4.ttf";